
/**
 * Tooltip for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
export default class Tooltip {
  /**
   * Tooltip constructor
   *
   * @param {HTMLElement} element - The tooltip trigger element
   * @param {Object} options - Configuration options
   */
  constructor(element, options = {}) {
    this.element = element;

    this.settings = Object.assign({
      tooltipTrigger: '.js_tooltip',
      tooltipDataText: 'data-tooltip-text',
      displayDuration: 4000,
      fadeOutDuration: 400
    }, options);

    this.init();
  }

  /**
   * Initialize the tooltip
   */
  init() {
    this.attachClickHandler();
  }

  /**
   * Attach click handler to the element
   */
  attachClickHandler() {
    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      this.createTooltip();
    });
  }

  /**
   * Create and show tooltip
   */
  createTooltip() {
    // Remove existing tooltip if any
    const existingTooltip = this.element.querySelector('.tooltip');
    if (existingTooltip) {
      existingTooltip.remove();
    }

    // Get tooltip text from data attribute
    const text = this.element.getAttribute(this.settings.tooltipDataText);
    if (!text) {
      console.warn('Tooltip: No text found in', this.settings.tooltipDataText);
      return;
    }

    // Create tooltip element
    const tooltip = document.createElement('span');
    tooltip.className = 'tooltip';
    tooltip.textContent = text;

    // Set position
    tooltip.style.right = '-7px';
    tooltip.style.bottom = '24px';
    tooltip.style.opacity = '1';

    // Append to trigger element
    this.element.appendChild(tooltip);

    // Auto-remove after delay with fade out
    setTimeout(() => {
      this.fadeOut(tooltip);
    }, this.settings.displayDuration);
  }

  /**
   * Fade out and remove tooltip
   * @param {HTMLElement} tooltip
   */
  fadeOut(tooltip) {
    if (!tooltip || !tooltip.parentNode) return;

    // Set initial transition
    tooltip.style.transition = `opacity ${this.settings.fadeOutDuration}ms ease-out`;
    tooltip.style.opacity = '0';

    // Remove from DOM after animation
    setTimeout(() => {
      if (tooltip && tooltip.parentNode) {
        tooltip.remove();
      }
    }, this.settings.fadeOutDuration);
  }

  /**
   * Destroy the tooltip instance
   */
  destroy() {
    const tooltip = this.element.querySelector('.tooltip');
    if (tooltip) {
      tooltip.remove();
    }
  }
}

/**
 * Initialize tooltips globally
 * @param {string} selector - CSS selector for tooltip triggers
 * @param {Object} options - Configuration options
 */
export function initTooltips(selector = '.js_tooltip', options = {}) {
  const tooltipElements = document.querySelectorAll(selector);
  const instances = [];

  tooltipElements.forEach(element => {
    const tooltip = new Tooltip(element, options);
    instances.push(tooltip);

    // Store instance on element for later access
    element._tooltipInstance = tooltip;
  });

  return instances;
}
